import { EFeedbackChatbotModalActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Открыть окно действия с оценкой чат-бота
 */
export const openFeedbackChatbotModal = actionGenerator<EFeedbackChatbotModalActionTypes.Open, void>(
  EFeedbackChatbotModalActionTypes.Open,
);

/**
 * Закрыть окно действия с оценкой чат-бота
 */
export const closeFeedbackChatbotModal = actionGenerator<EFeedbackChatbotModalActionTypes.Close, void>(
  EFeedbackChatbotModalActionTypes.Close,
);

/**
 * Поставить оценку чат-боту
 */
export const setFeedback = actionGenerator<EFeedbackChatbotModalActionTypes.SetRating, number>(
  EFeedbackChatbotModalActionTypes.SetRating,
);

/**
 * Оставить комментарий о работе чат-бота
 */
export const setFeedbackComment = actionGenerator<EFeedbackChatbotModalActionTypes.SetComment, string | null>(
  EFeedbackChatbotModalActionTypes.SetComment,
);

/**
 * Очистить фидбек по чат-боту
 */
export const resetFeedback = actionGenerator<EFeedbackChatbotModalActionTypes.Reset, void>(
  EFeedbackChatbotModalActionTypes.Reset,
);
